import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 24,
    height: 14,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 13,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(8px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(10px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#1877F2',
                ...theme.applyStyles('dark', {
                    backgroundColor: '#1877F2',
                }),
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 1px 3px 0 rgb(0 35 11 / 20%)',
        width: 10,
        height: 10,
        borderRadius: 5,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 14 / 2,
        opacity: 1,
        backgroundColor: 'rgba(33, 43, 54, 0.12)',
        boxSizing: 'border-box',
        ...theme.applyStyles('dark', {
            backgroundColor: 'rgba(33, 43, 54, 0.12)',
        }),
    },
}));


export default AntSwitch;